import { render, staticRenderFns } from "./BrickFilterExclusionSettings.vue?vue&type=template&id=733229db&scoped=true&"
import script from "./BrickFilterExclusionSettings.vue?vue&type=script&lang=js&"
export * from "./BrickFilterExclusionSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrickFilterExclusionSettings.vue?vue&type=style&index=0&id=733229db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733229db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733229db')) {
      api.createRecord('733229db', component.options)
    } else {
      api.reload('733229db', component.options)
    }
    module.hot.accept("./BrickFilterExclusionSettings.vue?vue&type=template&id=733229db&scoped=true&", function () {
      api.rerender('733229db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickFilterExclusionSettings.vue"
export default component.exports